export enum EmbeddedMode {
    FALSE, TRUE , READONLY
}
